import type { CalendarEntry } from './types'

export function composerUrlForEntry(entry: CalendarEntry): string {
  if (!entry.creativeId) return '/compose'
  // Composer is project-mode. Prefer the project URL so the page renders
  // without round-tripping creative→project (which causes a visible reload).
  const id = entry.projectId ?? entry.creativeId
  return entry.channel ? `/compose/${id}/${entry.channel}` : `/compose/${id}`
}
